const { categoryLevels } = require('../../shop/categories/categories.constants'), { find } = require('lodash');

const browseRouteConfigBuilder = function (level, uriParam, parentParam) {
    return {
        url: `/:${uriParam}`,
        reloadOnSearch: false,
        resolve: {
            [uriParam]: ['$stateParams', parentParam, ($stateParams, parentCategory) => {
                // Find the category object matching the url friendly name in the url.
                // Searches all of the states at the given state level (department, category, subcategory).
                // At department level this is the top level categories..
                if (parentCategory && parentCategory.Children) {
                    return find(parentCategory.Children, { UrlFriendlyName: $stateParams[uriParam] });
                }
                return undefined;
            }],
            isRestricted: ['ShopperService', uriParam, (shopperService, category) =>
                shopperService.IsGuest && category && category.IsRestricted,
            ],
        },
        onEnter: ['$state', 'CategoriesService', 'LoginService', 'ShopperService', 'isRestricted', categoryLevels[0], uriParam, ($state, categoriesService, loginService, shopperService, isRestricted, department, category) => {
            if (shopperService.IsGuest && !category && !department && department.IsSpecial) {
                $state.transition.then(() => {
                    if ($state.includes(`**.${uriParam}`)) {
                        loginService.promptForLogin(loginService.LoginToViewCategoryMessage);
                    }
                });
            } else if (!category) {
                $state.go('root', null, { location: 'replace' });
            } else if (isRestricted) {
                $state.transition.then(() => {
                    if ($state.includes(`**.${uriParam}`)) {
                        loginService.promptForLogin(loginService.LoginToViewCategoryMessage);
                    }
                });
            } else {
                categoriesService.currentCategories.pushCategory(category);
            }
        }],
        onExit: ['CategoriesService', (categoriesService) => {
            categoriesService.currentCategories.popCategory();
        }],
        views: {
            'center-panel@shop': {
                controller: [uriParam, 'isRestricted', '$state', 'RichRelevanceService', function (category, isRestricted, $state, richRelevanceService) {
                    this.category = category;
                    this.isRestricted = isRestricted;
                    this.$state = $state;
                    if (category && category.NodeLevel) {
                        if (category.NodeId === richRelevanceService.mySpecialsGroupId) {
                            this.dynamicPlacementId = richRelevanceService.mySpecialsPlacement;
                        } else if (category.RichRelevanceId) {
                            this.dynamicPlacementId = richRelevanceService.specialsGroupPlacement;
                        } else {
                            this.dynamicPlacementId = richRelevanceService.getPlacementByCategoryLevel(category.NodeLevel);
                        }
                    }
                }],
                controllerAs: '$ctrl',
                template: `
                    <wow-tile-list-with-content>
                        <wow-browse-tile-list
                            ng-if="::!$ctrl.isRestricted"
                            category="$ctrl.category"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy"
                            filter="$ctrl.$state.params.filter"
                            token="$ctrl.$state.params.token">
                        </wow-browse-tile-list>

                        <wow-rr-carousel dynamic-placement-id="$ctrl.dynamicPlacementId"></wow-rr-carousel>
                    </wow-tile-list-with-content>
                `,
            },
            'left-panel@shop': {
                controller: [categoryLevels[0], parentParam, uriParam, function (departmentCategory, parentCategory, category) {
                    this.departmentCategory = departmentCategory;
                    this.category = category.Children.length ? category : parentCategory;
                    this.isSpecial = category.IsSpecial;
                    this.isBundle = category.IsBundle;
                }],
                controllerAs: '$ctrl',
                template: '<wow-browse-left-panel department-category="$ctrl.departmentCategory" category="$ctrl.category" is-special="$ctrl.isSpecial" is-bundle="$ctrl.isBundle" ng-if="!$breakpoints.isInSmallFormat"></wow-browse-left-panel>',
            },
            'rr-instrumentation-panel@root': {
                controller: [uriParam, '$state', function (category, $state) {
                    this.category = category;
                    this.$state = $state;
                }],
                controllerAs: '$ctrl',
                template: '<wow-rr-category-instrumentation page-group="Category" page-number="$state.params.pageNumber" current-category="$ctrl.category"></wow-rr-category-instrumentation>',
            },
        },
    };
};

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.browse', {
            url: '/browse?{pageNumber:int}&{sortBy}&{filter:filter}&{filterOpen:bool}&{openFilter:string}&{token}',
            abstract: true,
            resolve: {
                departments: ['CategoriesService', categoriesService => categoriesService.getAll().then(categories => ({ Children: categories }))],
            },
        })
        .state('shop.browse.department', browseRouteConfigBuilder(0, categoryLevels[0], 'departments'))
        .state('shop.browse.department.category', browseRouteConfigBuilder(1, categoryLevels[1], categoryLevels[0]))
        .state('shop.browse.department.category.subcategory', browseRouteConfigBuilder(2, categoryLevels[2], categoryLevels[1]));
};



// WEBPACK FOOTER //
// ./src/configuration/routes/browse.js